import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../../Shared/AdminLayout';
import ProfileCard from '../../../../Shared/ProfileCard';
import DataCard from '../../../../Shared/DataCard';
import DataContainer from '../../../../Shared/DataContainer';
import Icon from '../../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../../Shared/TextInput';
import LoadingButton from '../../../../Shared/LoadingButton';
import axios from 'axios';

function Item() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          products: data.products || [],
          items: data.items || [],
          filterArr: [],
          search: '',
          message: ''
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleChangeQty(e, i) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          let products = values.products;
          products[i].quantity = value;
          setValues(values => ({
               ...values,
               products: products
          }));
     }

     function handleCheck(e, prod, index) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          const _data = parseInt(e.target.value);
          let products = values.products;
          let items = values.items;
          if(items.indexOf(_data) == -1){
               items.push(_data);
               products.push(prod);
          }else{
               products.splice(items.indexOf(_data), 1);
               items.splice(items.indexOf(_data), 1);
          }
          setValues(values => ({
               ...values,
               products: products,
               items: items
          }));
     }

     function handleSearch(e){
          e.preventDefault();
          if(values.search != ''){
               setValues(values => ({
                    ...values,
                    message: ''
               }));
               axios.post(route('campaignContent.find.product'), values).then((response) => {
                    setValues(values => ({
                         ...values,
                         search: '',
                         filterArr: response.data.data,
                         message: response.data.message
                    }));
               }).catch((err) => {
                    setValues(values => ({
                         ...values,
                         filterArr: [],
                         message: err.response.data.message
                    }));
               });
          }
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          // const formData = toFormData(values, 'POST');
          Inertia.post(route('campaignContent.post.items', [data.campaign.id, data.id]), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="permission-c">
               <form onSubmit={handleSubmit}>
                    <ProfileCard>
                         <div className="md:col-span-1">
                              <div className="px-4 sm:px-0">
                                   <h3 className="text-lg font-medium text-gray-900">Campaign Content Info</h3>
                                   <p className="mt-5 text-sm font-semibold text-center text-gray-600">
                                        {data.campaign.name}
                                   </p>
                                   <div className="pt-1">
                                        <h3 className="font-semibold text-gray-700 text-center">{data.name}</h3>
                                        {data.photo && (<img src={data.photo} className="mx-auto w-20 mt-3 rounded-full" alt={data.name} />)}
                                        <h4 className="text-sm text-center text-gray-600">{data.slogan}</h4>
                                        <h4 className="mt-5 text-dm text-center uppercase font-semibold text-gray-600">{data.title}</h4>
                                        <p className="mt-3 text-sm text-justify text-gray-600">{data.description}</p>
                                   </div>
                                   <div className="hidden sm:block">
                                        <div className="py-8">
                                             <div className="border-t border-gray-400"></div>
                                        </div>
                                   </div>
                                   <h3 className="text-lg font-medium text-gray-900">Campaign Products</h3>
                                   <div className="pt-1">
                                        {(values.products.length > 0) && (<React.Fragment>
                                             <ul className="list-none pt-2 mt-2">
                                                  {values.products.map(({id, name, code, quantity, packs}, i) => {
                                                       return <li className={`flex p-2 mt-2 rounded bg-gray-300 shadow-md`} key={`p${id}`}>
                                                            <div className="w-3/4">
                                                                 <label className="flex items-center" htmlFor="perms">
                                                                      <input name="product[]" id="product[]" className="form-checkbox" type="checkbox" value={id} checked onChange={()=>handleCheck(event, {id, name, code, quantity, packs}, i)}/>
                                                                      <span className="font-semibold ml-2 text-md text-gray-700">{name} ({code})</span>
                                                                 </label>
                                                                 <p className="text-sm text-gray-500 pl-6">{packs.join(', ')}</p>
                                                            </div>
                                                            <TextInput
                                                                  className="form-input rounded-md shadow-sm inline w-1/4"
                                                                  label="Quantity"
                                                                  name="quantity"
                                                                  type="text"
                                                                  disable={false}
                                                                  readonly={false}
                                                                  errors={errors.quantity}
                                                                  value={quantity}
                                                                  onChange={()=>handleChangeQty(event, i)}
                                                             />
                                                       </li>
                                                  })}
                                             </ul>
                                             <div className="flex items-center justify-end px-4 py-3 bg-gray-100 text-right sm:px-6 rounded-b">
                                                  <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                       Save
                                                  </LoadingButton>
                                             </div>
                                        </React.Fragment>)}
                                   </div>
                              </div>
                         </div>
                         <DataCard>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('campaignContent.index', data.id)} className="bg-transparent border border-gray-500 text-sm text-gray-500 p-2 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100 inline-flex items-center">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="col-span-8 sm:col-span-4">
                                             {(values.message != '') && (<div className="bg-gray-600 text-white p-2 rounded-md shadow-sm mt-4 block w-5/6">{values.message}</div>)}
                                             <div className="flex mt-4">
                                                  <TextInput
                                                        className="form-input rounded-md shadow-sm mt-4 block w-5/6"
                                                        label="Search Products"
                                                        name="search"
                                                        type="text"
                                                        disable={false}
                                                        readonly={false}
                                                        errors={errors.search}
                                                        value={values.search}
                                                        onChange={handleChange}
                                                   />
                                                   <button onClick={handleSearch} className="mt-8 bg-gray-600 text-white active:bg-gray-600 font-semibold text-sm p-3 rounded hover:shadow-lg outline-none focus:outline-none ml-1">Search</button>
                                             </div>
                                             <div className="flex mt-4">
                                                  <ul className="overflow-auto h-128 list-none pt-2 mt-2">
                                                      {values.filterArr.map(({id, name, code, quantity, packs, isCheck}, i) => {
                                                           return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md ${(isCheck?'bg-blue-200':'')}`} key={id}>
                                                                <label className="flex items-center" htmlFor="perms">
                                                                     <input name="products[]" id="products[]" className="form-checkbox" type="checkbox" value={id} checked={isCheck} onChange={()=>handleCheck(event, {id, name, code, quantity, packs}, i)}/>
                                                                     <span className="font-semibold ml-2 text-sm text-gray-700">{name} ({code})</span>
                                                                </label>
                                                                <p className="text-sm text-gray-500 pl-6">{packs.join(', ')}</p>
                                                           </li>
                                                      })}
                                                 </ul>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </DataCard>
                    </ProfileCard>
               </form>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Item.layout = page => <AdminLayout children={page} header={'Add Item to Campaign Content'} />;

export default Item;
